import React, { useState } from "react";
import { MDBModal, MDBModalHeader, MDBModalBody } from "mdbreact";
import { IconStarFilled } from "@tabler/icons-react";
import "./RatingModal.css";

const QUESTIONS = [
  { key: "feedback", no: 1, label: "ความสะดวกในการใช้งาน" },
  { key: "feedback1", no: 2, label: "ทำงานได้ตรงตามความต้องการ" },
  { key: "feedback2", no: 3, label: "การแสดงผลและประมวลผลข้อมูลถูกต้อง" },
];

const LABELS = ["", "น้อยที่สุด", "น้อย", "ปานกลาง", "มาก", "มากที่สุด"];

const LEGEND = [
  { score: 5, text: "มากที่สุด" },
  { score: 4, text: "มาก" },
  { score: 3, text: "ปานกลาง" },
  { score: 2, text: "น้อย" },
  { score: 1, text: "น้อยที่สุด" },
];

function StarRow({ value, onChange }) {
  const [hover, setHover] = useState(0);
  const shown = hover || value;

  return (
    <div className="rating-stars" onMouseLeave={() => setHover(0)}>
      {[1, 2, 3, 4, 5].map((score) => (
        <button
          key={score}
          type="button"
          className={`rating-star${shown >= score ? " is-active" : ""}`}
          aria-label={`${score} ดาว ${LABELS[score]}`}
          onMouseEnter={() => setHover(score)}
          onFocus={() => setHover(score)}
          onBlur={() => setHover(0)}
          onClick={() => onChange(score)}
        >
          <IconStarFilled size={26} />
        </button>
      ))}
      {value > 0 ? <span className="rating-score-label">{LABELS[value]}</span> : null}
    </div>
  );
}

export default function RatingModal({ isOpen, values, onChange, onSubmit }) {
  const done = QUESTIONS.filter((item) => Number(values[item.key]) > 0).length;
  const complete = done === QUESTIONS.length;

  return (
    <MDBModal className="rating-modal" isOpen={isOpen} centered backdrop="static" keyboard={false}>
      <MDBModalHeader>
        <div className="rating-modal-heading">
          แบบประเมินการใช้ระบบ
          <span className="rating-modal-sub">ช่วยประเมิน 3 ข้อ เพื่อพัฒนาการให้บริการ</span>
        </div>
      </MDBModalHeader>
      <MDBModalBody>
        <div className="rating-progress">
          <span>
            ตอบแล้ว {done}/{QUESTIONS.length} ข้อ
          </span>
          <div className="rating-progress-bar">
            <span style={{ width: `${(done / QUESTIONS.length) * 100}%` }} />
          </div>
        </div>

        {QUESTIONS.map((item) => {
          const value = Number(values[item.key]) || 0;
          return (
            <div key={item.key} className={`rating-item${value > 0 ? " is-done" : ""}`}>
              <div className="rating-item-head">
                <span className="rating-item-no">{item.no}</span>
                <div className="rating-item-label">{item.label}</div>
              </div>
              <StarRow value={value} onChange={(score) => onChange(item.key, score)} />
            </div>
          );
        })}

        <div className="rating-legend">
          {LEGEND.map((item) => (
            <span key={item.score} className="rating-chip">
              <b>{item.score}</b> {item.text}
            </span>
          ))}
        </div>

        {!complete ? <div className="rating-hint">กรุณาตอบให้ครบ 3 หัวข้อก่อนส่งผลประเมิน</div> : null}

        <div className="rating-footer">
          <button type="button" className="rating-submit" disabled={!complete} onClick={onSubmit}>
            ส่งผลประเมิน
          </button>
        </div>
      </MDBModalBody>
    </MDBModal>
  );
}
